import './styles.css';
import React, { Component } from 'react';
import Card from '../../../CardNew';
import GeneralRibbonUtils from '../../GeneralRibbonUtils';
import { IMAGE } from '../../constants';
import { Button } from 'packages/components';
import Utils from 'src/utils/Utils';

class RibbonImage extends Component {
    constructor(props) {
        super(props);
        this.carruselTitle = props.carruselTitle;
        this.items = props.items;
        this.visibleItems = props.visibleItems;
        this.focusSettings = props.focusSettings;
        this.ribbonId = props.ribbonId;
        this.focusHandler = props.focusHandler;
        this.setMetricsEvent = props.setMetricsEvent;
        this.keyDownHandler = props.keyDownHandler;
        this.className = props.className;
        this.ribbonIndex = props.index;
        this.ribbonName = props.ribbonName || props.ribbonId;
    }

    componentDidMount() {
        Utils.setInitialFocusChangeTime('.aaf_button-primary', 900);
    }

    clickHandler(data) {
        const { history } = this.props;
        history.push(data.href);
    }

    render() {
        const { items } = this.props;
        return (
            <div className="ribbon-items ribbon-image">
                {this.visibleItems.map((node) => {
                    const node_item = node.item;
                    const key = Math.random() * 10;
                    const cardProps = {
                        id: key,
                        key: key,
                        ribbonIndex: this.ribbonIndex,
                        data: node_item,
                        type: IMAGE,
                        dataMetric: {
                            carruselTitle: this.carruselTitle,
                            cardPosition: GeneralRibbonUtils.getPosition(
                                this.items,
                                node_item.title
                            ),
                        },
                        focusable: true,
                        focusRight: `#${this.ribbonId} ${this.focusSettings.selector}`,
                        focusLeft: `#${this.ribbonId} ${this.focusSettings.selector}`,
                        focusHandler: this.focusHandler,
                        setMetricsEvent: this.setMetricsEvent,
                        href: '#',
                        keyDownHandler: this.keyDownHandler,
                        ribbonName: this.ribbonName,
                        onClick: () => {}
                    };
                    return <Card {...cardProps} />;
                })}
                <div className='card-image-button'>
                    <Button
                        className='button-image focusable'
                        type="button"
                        variant='primary'
                        onClick={() => this.clickHandler(items[0])}
                        >
                        {'SUSCRIBIRME MENSUAL'}
                    </Button>
                </div>
            </div>
        );
    }
}

export default RibbonImage;



// WEBPACK FOOTER //
// ./src/components/RibbonNew/RibbonTypes/RibbonImage/index.jsx